import { Award, Building2, Package, Share2, TrendingUp, Wallet } from 'lucide-react';
import type { AnalysisData } from '../../services/AnalysisApiClient';

/** Parachute Payments sub-step id — sidebar, routed form, and `AnalysisData` keys align via {@link PARACHUTE_SUB_ID_TO_DATA_KEY}. */
export type ParachuteWorkflowSubId =
  | 'severance'
  | 'cicBonus'
  | 'compIncreases'
  | 'equity'
  | 'buyerEquity'
  | 'otherPayments';

export const DEFAULT_PARACHUTE_WORKFLOW_SUB_ID: ParachuteWorkflowSubId = 'severance';

/** Nested view under Parachute → Equity Awards (sidebar + main panel). */
export type ParachuteEquitySubId = 'awards' | 'qa24c';

export const DEFAULT_PARACHUTE_EQUITY_SUB_ID: ParachuteEquitySubId = 'awards';

const PARACHUTE_WORKFLOW_SUB_ITEMS_DEF = [
  { id: 'severance' as const, label: 'Severance', icon: Wallet },
  { id: 'cicBonus' as const, label: 'CIC Bonuses', icon: Award },
  { id: 'compIncreases' as const, label: 'Comp Increases', icon: TrendingUp },
  { id: 'equity' as const, label: 'Equity Awards', icon: Share2 },
  { id: 'buyerEquity' as const, label: 'Buyer Equity Awards', icon: Building2 },
  { id: 'otherPayments' as const, label: 'Other Payments', icon: Package },
];

export type ParachuteWorkflowSubItem = (typeof PARACHUTE_WORKFLOW_SUB_ITEMS_DEF)[number];

/** Canonical order: workflow sidebar, Parachute form substeps, and API field groups. */
export const PARACHUTE_WORKFLOW_SUB_ITEMS: readonly ParachuteWorkflowSubItem[] = PARACHUTE_WORKFLOW_SUB_ITEMS_DEF;

/** UI sub-tab id → `AnalysisData` key (matches `AnalysisApiClient` / `SIDEBAR_DATA_KEYS.parachutePayments`). */
export const PARACHUTE_SUB_ID_TO_DATA_KEY: Record<ParachuteWorkflowSubId, keyof AnalysisData> = {
  severance: 'severanceData',
  cicBonus: 'cicBonusData',
  compIncreases: 'compIncreaseData',
  equity: 'equityData',
  buyerEquity: 'buyerEquityData',
  otherPayments: 'otherPaymentsData',
};
